/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Compat_5Inputs */

const en_pc_online_compat_5 = /** @type {(inputs: Pc_Online_Compat_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closing or reloading the tab while a document has unsaved changes makes the browser ask you to confirm first.`)
};

const zh_pc_online_compat_5 = /** @type {(inputs: Pc_Online_Compat_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档有未保存的修改时，关闭或刷新标签页会先弹出浏览器的确认提示。`)
};

/**
* | output |
* | --- |
* | "Closing or reloading the tab while a document has unsaved changes makes the browser ask you to confirm first." |
*
* @param {Pc_Online_Compat_5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_compat_5 = /** @type {((inputs?: Pc_Online_Compat_5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Compat_5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_compat_5(inputs)
	return zh_pc_online_compat_5(inputs)
});
export { pc_online_compat_5 as "pc.online.compat.5" }